import React, { useState } from "react";
import usePushNotifications from "./usePushNotifications";
import { Button } from "reactstrap";
import { successNotify } from "../../../Alerts/success";
import { faLessThan } from "@fortawesome/free-solid-svg-icons";

const PushNotifications = () => {
  const [disabled, setDisabled] = useState(false);

  const {
    userConsent,
    pushNotificationSupported,
    userSubscription,
    onClickAskUserPermission,
    onClickSendSubscriptionToPushServer,
    onClickSusbribeToPushNotification,
    pushServerSubscriptionId,
    onClickSendNotification,
    error,
    loading
  } = usePushNotifications();

  const isConsentGranted = userConsent === "granted";

  const handleClick = () => {
    onClickSendSubscriptionToPushServer();

    setDisabled(true);

    successNotify("Te-ai abonat la notificari");
  };

  const _getText = () => {
    if (loading) {
      return "Se incarca...";
    }

    if (userSubscription) {
      return "Esti abonat";
    } else {
      return "Aboneaza-te";
    }
  };

  const _isDisabled = () => {
    if (!userSubscription) {
      return false;
    }

    return true;
  };

  console.log(userSubscription);

  return (
    <Button
      disabled={_isDisabled()}
      // disabled={userSubscription}
      onClick={handleClick}
      className="first"
    >
      {_getText()}
    </Button>
  );
};

export default PushNotifications;
